import { ResourceModel } from "src/app/core/models/resource.model";

export class Role extends ResourceModel<Role> {
    id!: string
    name!: string
    users!: Array<string>
    permissions!: Array<any>
}